window.onload = function() { 
(function($) {
  let searchParams = new URLSearchParams(window.location.search)
  let cartOpen = searchParams.has('cart_show');

  if(cartOpen){
    setTimeout(function() {
      window?.updateCart();
      document.querySelector('body').classList.add('cart-sidebar-show');

      // Obtenha a URL atual
      let url = window.location.href;
      
      // Crie um objeto URL
      let urlObj = new URL(url);
      
      // Remova todos os parâmetros
      urlObj.search = '';
      
      // Atualize a URL no navegador
      window.history.replaceState({}, document.title, urlObj.href);
    }, 3000)
  }
})()
}